class ComboProducts extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.submitButton = this.querySelector('.combo-products__footer button[type="submit"]');
    this.checkboxes = this.querySelectorAll("[data-variant-checkbox]");
    this.quantityInputs = this.querySelectorAll("[data-quantity-input]");
    this.quantityButtons = this.querySelectorAll("[data-quantity-button]");
    this.totalPrice = this.querySelector("[data-total-price]");
    this.originalPrice = this.querySelector("[data-original-price]");
    this.init();
  }

  init() {
    this.bindEvents();
    this.updateTotalPrice();
  }

  updateTotalPrice() {
    let total = 0;
    let original = 0;
    let shouldquantity = 0;
    const triggerSku = this.dataset.triggerSku;

    const checkboxes = this.querySelectorAll("[data-variant-checkbox]");

    const checkedBoxes = Array.from(checkboxes).filter((checkbox) => {
      return checkbox.checked;
    });
    let requiredQuantity = 0
    const checkedBoxes2 = Array.from(checkboxes).filter((checkbox) => {
      if(checkbox.checked && checkbox.dataset.requiredDiscount == "true"){
         const quantity = parseInt(checkbox.closest(".combo-item").querySelector("[data-quantity-input]").value) || 1;
        requiredQuantity = Number(requiredQuantity) +Number(quantity) 
        return true
      }
      return  false
    }); 
    checkedBoxes.forEach((checkbox) => {
      if (checkbox.checked) {
        const price = parseFloat(checkbox.dataset.price / 100) || 0;
        const discount = parseFloat(checkbox.dataset.discount) || 0;
        const quantity = parseInt(checkbox.closest(".combo-item").querySelector("[data-quantity-input]").value) || 1;
        const sku = checkbox.dataset.sku;
        if (sku === triggerSku) {
          shouldquantity += parseInt(quantity);
        } 
        if (requiredQuantity < 2 ) {
          total += price * quantity;
          original = total;
        } else {
          total += ((price * (100 - Number(discount))) / 100) * quantity;
          original += price * quantity;
        }
      }
    });
    if (parseInt(shouldquantity) > 0) {
      this.querySelector(".combo-products__gift-info").style.display = "block";
      this.querySelector(".combo-products__gift-quantity").innerHTML = " x" + parseInt(shouldquantity);
    } else {
      this.querySelector(".combo-products__gift-info").style.display = "none";
    }
    if (this.totalPrice) {
      this.totalPrice.textContent = `$${(Math.round(total * 100) / 100).toFixed(2)}`;
    }
    if (this.originalPrice) {
      if (total == original) {
        this.originalPrice.textContent = "";
        return;
      }
      this.originalPrice.textContent = `$${original.toFixed(2)}`;
    }
  }

  bindEvents() {
    this.checkboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", () => this.updateTotalPrice());
    });

    this.quantityInputs.forEach((input) => {
      input.addEventListener("change", () => this.updateTotalPrice());
    });
    this.quantityButtons.forEach((button) => {
      button.addEventListener("click", () => this.updateTotalPrice());
    });
    // this.form.addEventListener('submit', this.handleSubmit.bind(this));
    this.submitButton.addEventListener("click", this.handleSubmit.bind(this));
  }

  async handleSubmit(event) {
    event.preventDefault();
    const newBotton = this.querySelector('.combo-products__footer button[type="submit"]');
    if (newBotton.getAttribute("aria-busy")) {
      return;
    }
    this.submitButton.setAttribute("disabled", true);
    this.submitButton.setAttribute("aria-busy", true);
    this.submitButton.style.pointerEvents = "none";
    let sectionsToBundle = ["variant-added"];
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:prepare-bundled-sections", {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      })
    );
    let sections = sectionsToBundle.join(",");
    try {
      const items = this.getFormItems();

      const discountCode = this.dataset.discountCode;
      if (discountCode) {
        await this.discountFetch(discountCode, items, sections);
      } else {
        this.addItemsToCart(items, sections);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  }

  async discountFetch(discount_code, items, sections) {
    let that = this;
    await fetch("/discount/" + discount_code, {
      method: "GET",
    })
      .then(() => that.addItemsToCart(items, sections))
      .catch((error) => {
        console.error("折扣码应用失败:", error);
        // 即使折扣码失败也继续加购
        that.addItemsToCart(items, sections);
      });
  }
  async addItemsToCart(items, sections) {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: items,
        sections,
      }),
    });
    if (response.ok) {
      let responseJson = await response.json();
      let cartContent = await this.createCartPromise();
      cartContent["sections"] = responseJson["sections"];
      this.dispatchEvent(
        new CustomEvent("variant:add", {
          bubbles: true,
          detail: {
            items: responseJson["items"],
            cart: cartContent,
          },
        })
      );
      // // 触发购物车更改事件
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:change", {
          bubbles: true,
          detail: {
            baseEvent: "variant:add",
            cart: cartContent,
          },
        })
      );
      this.submitButton.removeAttribute("disabled");
      this.submitButton.removeAttribute("aria-busy");
      this.submitButton.style.pointerEvents = "auto";
    } else {
      this.submitButton.removeAttribute("disabled");
      this.submitButton.removeAttribute("aria-busy");
      this.submitButton.style.pointerEvents = "auto";
      throw new Error("Failed to add items to cart");
    }
  }
  createCartPromise = () => {
    return new Promise(async (resolve) => {
      const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();

      resolve(cartContent);
    });
    //  <!-- // 2024/5/6 买一送一版 -- end -->
  };
  getFormItems() {
    const items = [];
    const triggerSku = this.dataset.triggerSku;
    const giftVariantId = this.dataset.giftVariantId;
    let shouldAddGift = false;
    let shouldItem = {};
    this.checkboxes.forEach((checkbox) => {
      if (checkbox.checked) {
        const variantId = checkbox.value;
        const quantity = checkbox.closest(".combo-item").querySelector("[data-quantity-input]").value;
        const sku = checkbox.dataset.sku;

        items.push({
          id: variantId,
          quantity: parseInt(quantity),
        });

        if (sku === triggerSku) {
          shouldAddGift = true;
          if (shouldItem.quantity) {
            shouldItem.quantity += parseInt(quantity);
          } else {
            shouldItem = {
              id: variantId,
              sku: sku,
              quantity: parseInt(quantity),
            };
          }
        }
      }
    });
    if (shouldAddGift && giftVariantId) {
      items.push({
        id: giftVariantId,
        quantity: shouldItem.quantity,
        properties: {
          _is_gift: true,
          _noPrmitEdit: true,
        },
      });
    }

    return items;
  }
}

customElements.define("combo-products", ComboProducts);

class ComboItem extends HTMLElement {
  constructor() {
    super();
    setTimeout(() => {
      this.variantTrigger = this.querySelector("[data-variant-popup-trigger]");
      this.dialog = this.querySelector(".variant-popup-dialog");
      this.dialogSubmit = this.querySelector(".variant-popup__footer button");
      this.init();
    }, 0);
  }

  init() {
    if (this.variantTrigger) {
      this.variantTrigger.addEventListener("click", this.handleVariantClick.bind(this));
    }

    if (this.dialog) {
      this.dialog.querySelector(".variant-popup__close").addEventListener("click", async () => {
        const comboProducts = this.closest("combo-products");
        await this.dialog.close();
        setTimeout(() => {
          const submitButton = comboProducts.querySelector('.combo-products__footer button[type="submit"]');
          submitButton.setAttribute("disabled", false);
          submitButton.removeAttribute("aria-busy", false);
        }, 50);
      });
    }
    if (this.dialogSubmit) {
      this.dialogSubmit.addEventListener("click", this.handleVariantSubmit.bind(this));
    }
  }
  handleVariantSubmit(event) {
    event.preventDefault();

    // 获取父级 combo-products 组件
    const comboProducts = this.closest("combo-products");

    if (comboProducts) {
      setTimeout(() => {
        comboProducts.updateTotalPrice();
      }, 1000);
    }
  }
  handleVariantClick(event) {
    event.preventDefault();
    if (this.dialog) {
      this.dialog.showModal();
    }
  }
}

customElements.define("combo-item", ComboItem);
